/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_RequiredInputs */



/**
* | output |
* | --- |
* | "required" |
*
* @param {Common_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_required = /** @type {((inputs?: Common_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("requis")
	if (locale === "es") return /** @type {LocalizedString} */ ("obligatorio")
	if (locale === "pt") return /** @type {LocalizedString} */ ("obrigatório")
	if (locale === "it") return /** @type {LocalizedString} */ ("obbligatorio")
	return /** @type {LocalizedString} */ ("required")
});